/* eslint-disable no-param-reassign */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { type Insight as BaseInsight, registerStandardChartInsight } from '../insightManager';
import { toArray } from '../../util/data';
import { findXAxisIndex } from '../../helper/standardChart';

type InsightData = {
  /** x 轴指标对应数据集字段 */
  x: string;
  /** 控制的长度 */
  length: number;
  /** 控制类型 */
  trimType: 'extend' | 'clip';
  /** 当trimType为extend时，x轴增加的数据 */
  extendData?: (number | string)[];
};

const type = 'TrimX';
const INSIGHT_FLAG = `insight_${type}`;

interface Insight extends BaseInsight<InsightData[]> {
  readonly type: typeof type;
}

registerStandardChartInsight<Insight>({
  type,
  filter: option => {
    return (
      toArray(option.xAxis).length > 0 &&
      toArray(option.yAxis).length > 0 &&
      !toArray(option.series).some(item => !['line', 'bar'].includes(item.type))
    );
  },
  clear: {
    onOptionUpdate(option) {
      option.xAxis = toArray(option.xAxis).map(axis => {
        if (!axis) {
          return;
        }

        axis.data = axis?.data?.filter(dataItem => !dataItem?.__insightFlag);
        return axis;
      });
    }
  },
  /** @see https://datav.iwencai.com/example.html#/static-page?id=252 */
  render: {
    onOptionUpdate(context, option) {
      const insight = context.insightOption;
      function render(data: InsightData) {
        const { x, length = 0, trimType, extendData = [] } = data;

        const xAxisIndex = findXAxisIndex(option, { xField: x });
        const targetDataArr = toArray(option.xAxis)[xAxisIndex]!.data;
        console.log('targetDataArr: ', targetDataArr);
        if (trimType === 'extend') {
          Array.from({ length }).forEach((_, index) => {
            targetDataArr.push({
              __insightFlag: INSIGHT_FLAG,
              value: extendData.length ? extendData[index] : ''
            });
          });
        }
        if (trimType === 'clip') {
          targetDataArr.splice(targetDataArr.length - length);
        }
      }

      insight.data.forEach(item => {
        render(item);
      });
    }
  }
});
